var UIYandexMapsWrapper = (function ($) {
    UIYandexMapsWrapper = function (options, callback) {
        var that = this;

        var def = function (var1, var2) {
            for (var i = 0, len = arguments.length; i < len; i++) {
                if (typeof arguments[i] !== 'undefined') {
                    return arguments[i];
                }
            }
            return undefined;
        };

        // DYNAMIC VARS
        that.ymaps = null;
        that.myMap = null;

        that.icons = {};
        that.balloons = {};

        // CONST
        that.geoCodeMoscow = [55.755864, 37.617698];

        that.map_center_coord = def(options.map_center_coord, that.geoCodeMoscow);
        that.map_zoom = options.map_zoom || 4;
        that.map_show_zoom_panel = def(options.map_show_zoom_panel, true);

        that.strokeColors = {
            main: "#330072",
        };

        that.strokeStyle = {
            dash: "dash",
        };

        // INIT
        that.ready(options, callback);
    };

    /**
     * Ждем загрузки всех элементов ymaps.
     * @param [callback] функция результата загрузки, на вход принимает в параметре ymaps объект.
     **/
    UIYandexMapsWrapper.prototype.ready = function (options, callback) {
        var that = this;

        // Динамическая подгрузка контента ломает инициализацию ymaps скриптов
        // На странице не работает вторая подгрузка yandex maps
        if (window.ymaps) {
            that.makeFieldMap(window.ymaps);
    
            setTimeout(function () {
                callback();
            });

            return;
        }

        var initFunc = '_mapOnLoad'+Math.round(Math.random()*1000);

        window[initFunc] = function() {
            that._defineModuleAnimatedLine();

            // Функция ymaps.ready() будет вызвана, когда
            // загрузятся все компоненты API, а также когда будет готово DOM-дерево.
            window.ymaps.ready(["AnimatedLine"]).then(function (ymaps) {
                that.makeFieldMap(ymaps);
    
                callback();
            });
        };

        $.getScript(
            "https://api-maps.yandex.ru/2.1/?" +
            /*"&mode=debug"+*/
            "&apikey=" + options.yandex_map_api_key +
            "&lang=" + $.sa.current_locale_config.code +
            "&onload=" + encodeURIComponent(initFunc)
        );
    };

    UIYandexMapsWrapper.prototype.makeFieldMap = function (ymaps) {
        var that = this;

        that.createMap(ymaps);
        that.createIcons(ymaps);
        that.createBalloons(ymaps);
    };

    UIYandexMapsWrapper.prototype.createMap = function (ymaps) {
        var that = this;

        // Обновляем объект ymaps
        that.ymaps = ymaps;

        // Создание карты.
        that.myMap = new that.ymaps.Map(
            "map",
            {
                // Координаты центра карты.
                center: that.map_center_coord,
                // Уровень масштабирования. Допустимые значения:
                // от 0 (весь мир) до 19.
                zoom: that.map_zoom,
                controls: [],
                type: "yandex#map",
            },
            {
                suppressMapOpenBlock: true,
                suppressObsoleteBrowserNotifier: true,
                yandexMapDisablePoiInteractivity: true,
                yandexMapAutoSwitch: false,
                yandexMapSuppressMapOpenBlock: true,
                minZoom: Math.min(Math.abs(that.map_zoom - 3), 0),
                maxZoom: Math.min(that.map_zoom + 3, 19),
                restrictMapArea: [[83.23618,-178.9], [-78.87011,181]]
            }
        );

        // Запрещаем скроллинг на мобилке
        if ($.sa.is_mobile()) {
            that.myMap.behaviors.disable('scrollZoom');
            that.myMap.behaviors.disable('drag');
        }

        // Добавим на карту поисковую строку.
        that.map_show_zoom_panel && that.myMap.controls.add("zoomControl", {
            float: "none",
            position: {
                top: "100px",
                right: "30px",
            },
        });
    };

    UIYandexMapsWrapper.prototype.createIcons = function (ymaps) {
        var that = this;

        that.icons = {
            active: ymaps.templateLayoutFactory.createClass(
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="5.5" fill="white" stroke="#FF585D" stroke-width="5"/></svg>'
            ),
            standard: ymaps.templateLayoutFactory.createClass(
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="5.5" fill="white" stroke="#330072" stroke-width="5"/></svg>'
            ),
            inactive: ymaps.templateLayoutFactory.createClass(
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="5.5" fill="white" stroke="#ADAABF" stroke-width="5"/></svg>'
            ),
            office: ymaps.templateLayoutFactory.createClass(
                '<svg style="margin-top: -29px; margin-left: -25px;" width="50" height="57" viewBox="0 0 50 57" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25.001" r="25" fill="#330072"/><path d="M20.6907 22.5712L19.3307 27.5646C19.2174 27.9335 19.4724 28.3023 19.8691 28.359L24.4875 28.9265C24.6008 28.9265 24.5725 29.0967 24.4875 29.0967L19.6424 29.6074C19.1324 29.6641 18.679 30.033 18.5374 30.5437L17.0073 36.218C16.9507 36.4734 17.234 36.7004 17.4607 36.5301L28.9642 29.2386C29.1343 29.1251 29.1626 28.8981 28.9926 28.7562L21.1724 22.4293C21.0024 22.2875 20.7474 22.3726 20.6907 22.5712Z" fill="#FF585D"/><path d="M29.7852 27.9906L31.1452 22.9971C31.2586 22.6283 31.0035 22.2595 30.6069 22.2027L25.9884 21.6353C25.8751 21.6353 25.9034 21.4651 25.9884 21.4651L30.8336 20.9827C31.3436 20.926 31.7969 20.5572 31.9386 20.0465L33.4686 14.3721C33.5253 14.1167 33.2419 13.8898 33.0153 14.06L21.5117 21.3516C21.3417 21.4651 21.3134 21.692 21.4834 21.8339L29.3035 28.1892C29.4735 28.2743 29.7285 28.2175 29.7852 27.9906Z" fill="white"/><ellipse cx="25" cy="56.001" rx="6" ry="1" fill="#330072" fill-opacity="0.2"/><path d="M25 56.001C24.5 56.001 21 48.001 21 48.001H29C29 48.001 25.5 56.001 25 56.001Z" fill="#330072"/></svg>'
            ),
        };
    };

    UIYandexMapsWrapper.prototype.createBalloons = function (ymaps) {
        var that = this;

        that.balloons = {
            airplane_takeoff: () => ymaps.templateLayoutFactory.createClass(
                '<div class="tooltip-wrapper focus">' +
                    '<span class="tooltip light top">' +
                        '<span class="flex flex-left flex-middle gap-extra-small">' +
                            '<svg class="svg-inline--fa fa-sa-fill-airplane-takeoff fa-w-16 icon gray medium" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="sa-fill-airplane-takeoff" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-fa-i2svg=""><path fill="currentColor" d="M14.846,11.686l4.814-1.351a1.92,1.92,0,0,1,1.534.235,2.326,2.326,0,0,1,.832,2.971,1.918,1.918,0,0,1-1.189,1L6.393,18.59,1.74,13.1l2.89-.812,2.516,1.562,2.89-.812L6.048,6.221,8.939,5.41ZM0,0ZM24,24Z"></path></svg>' +
                            '<span>{{properties.city_name}}</span>' +
                            '<svg class="svg-inline--fa fa-sa-x fa-w-16 icon gray medium margin-left-auto {{properties.close}}" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="sa-x" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-fa-i2svg=""><path fill="currentColor" d="M18.707,6.707a1,1,0,1,0-1.414-1.414L12,10.586,6.707,5.293A1,1,0,0,0,5.293,6.707L10.586,12,5.293,17.293a1,1,0,0,0,1.414,1.414L12,13.414l5.293,5.293a1,1,0,0,0,1.414-1.414L13.414,12ZM0,0ZM24,24Z"></path></svg>' +
                        '</span>' +
                    '</span>' +
                '</div>'
            ),
            airplane_landing: () => ymaps.templateLayoutFactory.createClass(
                '<div class="tooltip-wrapper focus">' +
                    '<span class="tooltip light top">' +
                        '<span class="flex flex-left flex-middle gap-extra-small width-1-1">' +
                            '<svg class="svg-inline--fa fa-sa-fill-airplane-landing fa-w-16 icon gray medium" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="sa-fill-airplane-landing" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-fa-i2svg=""><path fill="currentColor" d="M14.859,13.809,19.688,15.1a1.913,1.913,0,0,1,1.2.984,2.327,2.327,0,0,1-.8,2.98,1.919,1.919,0,0,1-1.531.251L4.067,15.436l-1.2-7.1,2.9.776,1.367,2.626,2.9.776.045-7.894,2.9.777ZM0,0ZM24,24Z"></path></svg>' +
                            '<span>{{properties.city_name}}</span>' +
                            '<svg class="svg-inline--fa fa-sa-x fa-w-16 icon gray medium margin-left-auto {{properties.close}}" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="sa-x" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-fa-i2svg=""><path fill="currentColor" d="M18.707,6.707a1,1,0,1,0-1.414-1.414L12,10.586,6.707,5.293A1,1,0,0,0,5.293,6.707L10.586,12,5.293,17.293a1,1,0,0,0,1.414,1.414L12,13.414l5.293,5.293a1,1,0,0,0,1.414-1.414L13.414,12ZM0,0ZM24,24Z"></path></svg>' +
                        '</span>' +
                        '{% if properties.use_button %}' +
                        '<button class="button small margin-top-extra-small {{properties.link}}">{{properties.link_text}}</button>' +
                        '{% endif %}' +
                    '</span>' +
                '</div>'
            ),
        };
    };

    UIYandexMapsWrapper.prototype.addAnimatedLine = function (
        points,
        properties,
        options
    ) {
        var that = this;

        var line = new that.ymaps.AnimatedLine(
            points,
            Object.assign({}, properties),
            Object.assign(
                {
                    animationTime: 1000,
                    geodesic: true,
                    strokeWidth: 3,
                    strokeColor: that.strokeColors.main,
                    cursor: "default" // disable cursor
                },
                options
            )
        );

        that.myMap.geoObjects.add(line);

        return line.animate();
    };

    UIYandexMapsWrapper.prototype.addIcon = function (
        points,
        properties,
        options
    ) {
        var that = this;

        var icon = new ymaps.GeoObject(
            {
                geometry: {
                    type: "Point",
                    coordinates: points,
                },
                properties: Object.assign({}, properties),
            },
            Object.assign(
                {
                    iconLayout: undefined,
                    iconOffset: [-8, -8],
                    iconShape: {
                        type: "Circle",
                        coordinates: [8, 8],
                        radius: 10,
                    },
                    openBalloonOnClick: false,
                    hideIconOnBalloonOpen: false,
                    zIndex: 650,
                    zIndexActive: 650,
                    zIndexHover: 650,
                },
                options
            )
        );

        that.myMap.geoObjects.add(icon);

        return icon;
    };

    UIYandexMapsWrapper.prototype.addBalloon = function (
        points,
        properties,
        options
    ) {
        var that = this;

        var balloon = new ymaps.GeoObject(
            {
                geometry: {
                    type: "Point",
                    coordinates: points,
                },
                properties: Object.assign({}, properties),
            },
            Object.assign(
                {
                    iconLayout: undefined,
                    iconOffset: [0, -24],
                    iconShape: {
                        type: "Circle",
                        coordinates: [0, 0],
                        radius: 0,
                    },
                    openBalloonOnClick: false,
                    hideIconOnBalloonOpen: false,
                    zIndex: 700,
                    zIndexActive: 700,
                    zIndexHover: 700,
                    pane: 'overlaps'
                },
                options
            )
        );

        that.myMap.geoObjects.add(balloon);

        return balloon;
    };

    UIYandexMapsWrapper.prototype.removeAllObjects = function () {
        var that = this;

        that.myMap.geoObjects.removeAll();
    }

    UIYandexMapsWrapper.prototype._defineModuleAnimatedLine = function () {
        var that = this;

        /**
         * @fileOverview Анимированная линия.
         */
        /**
         * Создает экземпляр анимированной линии.
         * @class AnimatedLine. Представляет собой геообъект с геометрией geometry.LineString.
         * @param [options.animationTime = 4000] Длительность анимации.
         **/
        function AnimatedLine(geometry, properties, options) {
            AnimatedLine.superclass.constructor.call(
                this,
                geometry,
                properties,
                options
            );
            this._loopTime = this.options.get("loopTime", 50);
            this._animationTime = this.options.get("animationTime", 1000);
            // Вычислим длину переданной линии.
            var distance = 0,
                previousElem = geometry[0];
            this.geometry.getCoordinates().forEach(function (elem) {
                distance += that._getDistance(elem, previousElem);
                previousElem = elem;
            });

            // Вычислим минимальный интервал отрисовки.
            this._animationInterval =
                (distance / this._animationTime) * this._loopTime;
            this._steps = this._animationTime / this._loopTime;
            // Создадим массив с более частым расположением промежуточных точек.
            this._smoothCoords = that._generateSmoothCoords(
                geometry,
                this._steps
            );
        }

        ymaps.modules.define(
            "AnimatedLine",
            ["util.defineClass", "Polyline", "vow"],
            function (provide, defineClass, Polyline, vow) {
                defineClass(AnimatedLine, Polyline, {
                    // Анимировать линию.
                    start: function () {
                        var value = 0,
                            coords = this._smoothCoords,
                            line = this,
                            loopTime = this._loopTime;

                        // Будем добавлять по одной точке каждые 50 мс.
                        function loop(value, currentTime, previousTime) {
                            if (value < coords.length) {
                                if (
                                    !currentTime ||
                                    currentTime - previousTime > loopTime
                                ) {
                                    line.geometry.set(value, coords[value]);
                                    value++;
                                    previousTime = currentTime;
                                }
                                requestAnimationFrame(function (time) {
                                    loop(value, time, previousTime || time);
                                });
                            } else {
                                // Бросаем событие окончания отрисовки линии.
                                line.events.fire("animationfinished");
                            }
                        }

                        loop(value);
                    },
                    // Убрать отрисованную линию.
                    reset: function () {
                        this.geometry.setCoordinates([]);
                    },
                    // Запустить полный цикл анимации.
                    animate: function () {
                        this.reset();
                        this.start();
                        var deferred = vow.defer();
                        this.events.once("animationfinished", function () {
                            deferred.resolve();
                        });
                        return deferred.promise();
                    },
                });

                provide(AnimatedLine);
            }
        );
    };

    // Функция генерации частых координат по заданной линии.
    UIYandexMapsWrapper.prototype._generateSmoothCoords = function (
        coords,
        steps
    ) {
        var smoothCoords = [],
            cLat = ((coords[0][0] + coords[1][0]) / 2),
            cLon = ((coords[0][1] + coords[1][1]) / 2);

        // задаем отклонение
        if (Math.abs(coords[0][1] - coords[1][1]) < 0.0001) {
            cLon -= 1.5195;
        } else {
            cLat += 1.5195;
        }

        var tDelta = 1.0 / steps;
        for (var t = 0; t <= 1.0; t += tDelta) {
            var oneMinusT = (1.0 - t),
                t2 = Math.pow(t, 2),
                lon = oneMinusT * oneMinusT * coords[0][1]
                + 2 * oneMinusT * t * cLon
                + t2 * coords[1][1],
                lat = oneMinusT * oneMinusT * coords[0][0]
                + 2 * oneMinusT * t * cLat
                + t2 * coords[1][0];
            smoothCoords.push([lat, lon]);
        }
        smoothCoords.push(coords[1]);
        return smoothCoords;

    };

    // Функция нахождения расстояния между двумя точками на плоскости.
    UIYandexMapsWrapper.prototype._getDistance = function (point1, point2) {
        return Math.sqrt(
            Math.pow(point2[0] - point1[0], 2) +
            Math.pow(point2[1] - point1[1], 2)
        );
    };

    return UIYandexMapsWrapper;
})($);
